import { PdAPI } from './types'
import { filterQueryParams } from '@/utils'
import queryString from 'query-string'

export const pdApi: PdAPI = ky => {
  return {
    async fetch({ patientId, year, month }) {
      const searchParams = filterQueryParams({ year, month })

      return ky(`patient/${patientId}/pd/`, {
        method: 'get',
        searchParams: queryString.stringify(searchParams)
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/pd/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async fetchExitsiteImage({ patientId, pdId }) {
      return ky(`patient/${patientId}/pd/${pdId}/exitsite_image/`, {
        method: 'get'
      }).blob()
    },

    async fetchWasteFluidImage({ patientId, pdId }) {
      return ky(`patient/${patientId}/pd/${pdId}/waste_fluid_image/`, {
        method: 'get'
      }).blob()
    }
  }
}
